import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/api.service';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss']
})
export class FooterComponent implements OnInit {
  categories: any;
  subCategories: any;

  constructor(private apiService: ApiService) { }

  ngOnInit(): void {
    this.loadCategories();
  }
  loadCategories(){
    this.apiService.loadCategories().then((result => {
      this.categories = result
    }))
  }
  showSubcategory(show: boolean, category: any){
    if(show){
      this.subCategories = category.categorias;

    } else{
      this.subCategories = [];
    }
  }
}
